 <nav class="sidebar-nav">
    <ul class="nav">
      <ng-template ngFor let-navitem [ngForOf]="navigation">
        <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
        <ng-template [ngIf]="isTitle(navitem) && isAllowed(navitem)">
          <app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
        </ng-template>
        <ng-template
          [ngIf]="
            !isDivider(navitem) &&
            !isTitle(navitem) &&
            isAllowed(navitem) &&
            hasId(navitem)
          "
        >
          <app-sidebar-nav-item [item]="navitem"></app-sidebar-nav-item>
        </ng-template>
        <ng-container *ngIf="navitem['id']">
          <li *ngIf="navitem['id'] === 'change-password'">
            <app-reset-pwd></app-reset-pwd>
          </li>
          <li
            *ngIf="
              navitem['id'] === 'feedback'
            "
          >
            <div class="row p-0 m-0" style="padding: 0.5rem 0.1rem !important">
              <button
                type="button"
                (click)="feedback()"
                class="btn btn-success bg-transparent border-0 text-left"
                style="font-weight: 500"
              >
                <fa-icon
                  class="white-icon pr-2"
                  [icon]="['fa', navitem['icon']]"
                  style="opacity: 0.5"
                ></fa-icon>
                {{ navitem["name"] }}
              </button>
            </div>
          </li>
        </ng-container>
      </ng-template>

      <li class="text-center text-muted mt-2">
        Version: <strong>{{ version }}</strong>
      </li>
      <li class="text-center text-muted" *ngIf="env !== 'production'">
        Environment: <strong class="text-capitalize">{{ env }}</strong>
      </li>
    </ul>
  </nav>